import React, { useEffect, useState } from "react";
import { Box, Paper, Typography } from "@mui/material";
import { DataGridPro, useGridApiRef } from "@mui/x-data-grid-pro";
import axios from "axios";
import { APIURL } from "../../../config";

const columns = [
    { field: "employee", headerName: "Employee", flex: 1, minWidth: 160 },
    { field: "blocked_count", headerName: "Workflows Blocked", type: "number", width: 100 },
];

export default function EmployeeLoad(props) {
    const apiRef = useGridApiRef();
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const compID = props.comp_id || (props.user && props.user.comp_id);
        if (!compID) {
            setLoading(false);
            return;
        }
        axios.get(APIURL + "/workflows/dashboard/employee-load", {
            params: { compID }
        }).then((response) => {
            const data = Array.isArray(response.data) ? response.data : [];
            setRows(data);
            if (props.onRowCountChange) props.onRowCountChange(data.length);
        }).catch((error) => {
            console.log(error);
        }).finally(() => {
            setLoading(false);
        });
    }, [props.comp_id, props.user]);

    return (
        <Paper sx={{ height: "100%", display: "flex", flexDirection: "column", p: 2 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                Employee Load
            </Typography>
            <Typography variant="caption" color="text.secondary" sx={{ mb: 1 }}>
                Users blocking workflows — employees assigned to active instances that still have open tasks, with a count of workflows waiting on them.
            </Typography>
            <Box sx={{ flex: 1, minHeight: 0 }}>
                <DataGridPro
                    apiRef={apiRef}
                    rows={rows}
                    columns={columns}
                    getRowId={(row) => row.id}
                    loading={loading}
                    density="compact"
                    disableRowSelectionOnClick
                    sx={{
                        '& .MuiDataGrid-columnHeaderTitle': {
                            whiteSpace: 'normal',
                            lineHeight: 1.2,
                            textAlign: 'left',
                            wordBreak: 'break-word',
                            maxWidth: '100%',
                        },
                    }}
                />
            </Box>
        </Paper>
    );
};
